import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { config } from 'app/shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { CurrentUser, SucursalRol, Sucursal } from 'app/core/model/trjireh-model';

@Injectable()
export class AuthApiService {

  access: any[] = [];

  usuario: any[] = [];

  constructor(public http: HttpClient) { }

  public login(userRequest): Observable<any> {

    const headers = this.getHeaders();

    const param = JSON.stringify(userRequest);

    return this.http.post(config.API_DATA_URL + '/Auth/Acceso', param, { headers })
      .map((access: any) => {
        this.usuario = access;
        return this.usuario;
      })
      // .delay(100)
      // .map((data: any)=>(data.data|| data))
      // .catch(this.handleError)
      .catch((error: any) => {
        if (error.status === 404) {
          return Observable.throw(new Error('No se encontro el usuario'));
        } else {
          return Observable.throw(new Error(error.status));
        }
      });
  }

  public GetIdEmpleadoLogged(): number {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    
    return currentUser ? currentUser.idEmpleado : -1;
  }

  public CambiarPassword(userRequest): Observable<any> {
    const headers = this.getHeaders();
    const param = JSON.stringify(userRequest);

    return this.http.post(config.API_DATA_URL + '/Auth/CambiarPassword', param, { headers })
      .map((response: any) => {
        return response;
      })
      // .delay(100)
      // .map((data: any)=>(data.data|| data))
      // .catch(this.handleError)
      .catch((error: any) => {
        if (error.status === 404) {
          return Observable.throw(new Error('No se encontro el usuario'));
        } else {
          return Observable.throw(new Error(error.status));
        }
      });
  }

  public SetCurrentAccess(current: CurrentUser, sucursales: Sucursal[], sucRol: SucursalRol) {
    localStorage.setItem('currentUser', JSON.stringify(current));
    localStorage.setItem('sucursales', JSON.stringify(sucursales));
    localStorage.setItem('sucursalRol', JSON.stringify(sucRol));
  }

  public GetRolEnabled(rol: string): boolean {

    // const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const sucursalRol = JSON.parse(localStorage.getItem('sucursalRol'));
    if (sucursalRol) {

      if (sucursalRol.roles && sucursalRol.roles.length > 0) {
        return sucursalRol.roles.filter(r => r.clave == rol).length > 0;
      }
    }

    return false;
  }

  public getAccess(url): Observable<any> {
    const headers = this.getHeaders();

    return this.http.get(config.API_DATA_URL + url, { headers })
      .map((access: any) => {
        this.access = access;
        return this.access;
      })
      // .delay(100)
      // .map((data: any)=>(data.data|| data))
      .catch(this.handleError)

  }

  private getBaseUrl() {
    return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/'
  }

  private getHeaders(): HttpHeaders {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/auth-api.service.ts